class CollectionTagFilter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.filterTitles = this.querySelectorAll('.collection-filter__item-title');
    if (this.filterTitles.length === 0) return;
    
    this.addEventListeners();
    this.setInitialActiveState();
  }

  addEventListeners() {
    this.filterTitles.forEach(title => {
      title.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleFilterClick(title);
      });
    });
  }

  handleFilterClick(clickedTitle) {
    const currentUrl = window.location.pathname;
    const collectionMatch = currentUrl.match(/\/collections\/([^\/\?]+)/);
    
    if (!collectionMatch) return;
    
    const collectionHandle = collectionMatch[1];
    const filterValue = clickedTitle.textContent.trim().toLowerCase();
    
    if (clickedTitle.classList.contains('active--filters')) {
      this.removeFilter(clickedTitle, collectionHandle);
    } else {
      this.applyFilter(clickedTitle, collectionHandle, filterValue);
    }
  }

  async removeFilter(clickedTitle, collectionHandle) {
    this.filterTitles.forEach(el => {
      el.classList.remove("active--filters");
    });

    const newUrl = `/collections/${collectionHandle}`;
    window.history.replaceState(null, null, newUrl);

    try {
      const response = await fetch(newUrl);
      if (response.ok) {
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        
        this.updateCollectionContent(doc);
      } else {
        console.error("HTTP-Error: " + response.status);
      }
    } catch (error) {
      console.error("Error fetching collection:", error);
    }
  }

  async applyFilter(clickedTitle, collectionHandle, filterValue) {
    this.filterTitles.forEach(el => {
      el.classList.remove("active--filters");
    });
    clickedTitle.classList.add('active--filters');

    const newUrl = `/collections/${collectionHandle}/${filterValue}`;
    window.history.replaceState(null, null, newUrl);

    try {
      const response = await fetch(newUrl);
      if (response.ok) {
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        
        this.updateCollectionContent(doc);
      } else {
        console.error("HTTP-Error: " + response.status);
      }
    } catch (error) {
      console.error("Error fetching collection:", error);
    }
  }

  updateCollectionContent(doc) {
    const currentCollection = document.querySelector('.collection');
    if (!currentCollection) return;
    
    const newCollection = doc.querySelector('.collection');
    if (!newCollection) return;
    
    const currentActiveFilter = document.querySelector('.collection-filter__item-title.active--filters');
    const activeFilterText = currentActiveFilter ? currentActiveFilter.textContent.trim().toLowerCase() : null;
    
    currentCollection.innerHTML = newCollection.innerHTML;
    
    if (activeFilterText) {
      const filterTitles = document.querySelectorAll('.collection-filter__item-title');
      filterTitles.forEach(title => {
        if (title.textContent.trim().toLowerCase() === activeFilterText) {
          title.classList.add('active--filters');
        }
      });
    }
    
    if (typeof window.initProductCards === 'function') {
      window.initProductCards();
    }
    
    document.dispatchEvent(new CustomEvent('collection:updated', {
      detail: { 
        url: window.location.href,
        timestamp: Date.now()
      }
    }));
  }

  setInitialActiveState() {
    const currentUrl = window.location.pathname;
    const urlParts = currentUrl.split('/');
    
    if (urlParts.length > 3) {
      const currentFilter = urlParts[3];
      
      this.filterTitles.forEach(title => {
        if (title.textContent.trim().toLowerCase() === currentFilter.toLowerCase()) {
          title.classList.add('active--filters');
        }
      });
    } else {
      console.log('No filter in URL - all filters inactive');
    }
  }
}

if (!window.customElements.get('collection-tag-filter')) {
  window.customElements.define('collection-tag-filter', CollectionTagFilter);
}
